<div class="bot-content__config" [class.visible]="visible">
  <form class="form" [formGroup]="botConfigForm">
    <div class="conversation-filters__row">
      @if (!bot?.type || (bot && ['botCreator', 'quizBot'].includes(bot.type))) {
        <div class="form-field">
          <h4 class="m-t-0 mb-1">Language</h4>
          <div class="form-field-container">
            <label for="language-select" class="form-field-label">Language</label>
            <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
              <mat-select id="language-select" formControlName="language" placeholder="Select language">
                @for (language of languages; track language.code) {
                  <mat-option [value]="language">{{ language.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="form-field">
          <h4 class="m-t-0 mb-1">Project</h4>
          <div class="form-field-container">
            <label for="project-select" class="form-field-label">Project</label>
            <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
              <mat-select id="project-select" placeholder="Select projects" formControlName="_id">
                @for (project of formProjects; track project._id; let i = $index) {
                  <mat-option [value]="project._id">{{ project.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      } @else {
        <div class="form-field conversation-filters__field--span-2">
          <h4 class="m-t-0 mb-1">Project</h4>
          <div class="form-field-container">
            <label for="project-select" class="form-field-label">Project</label>
            <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
              <mat-select id="project-select" placeholder="Select projects" formControlName="_id">
                @for (project of formProjects; track project._id; let i = $index) {
                  <mat-option [value]="project._id">{{ project.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
    </div>
    <div class="conversation-filters__row">
      <div class="form-field">
        <h4 class="m-t-0 mb-1">Date</h4>
        <div class="form-field-container">
          <label for="date-range" class="form-field-label">Date Range</label>
          <mat-form-field class="gingr-input-wrapper w-full conversation-filters__date-range" appearance="outline">
            <mat-date-range-input id="date-range" [rangePicker]="picker">
              <input matStartDate formControlName="start" placeholder="DD.MM.YYYY" />
              <input matEndDate formControlName="end" placeholder="DD.MM.YYYY" />
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
      <div class="form-field">
        <h4 class="m-t-0 mb-1">Country</h4>
        <div class="form-field-container">
          <label for="country-select" class="form-field-label">Country</label>
          <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
            <mat-select id="country-select" (focus)="resetCountrySearch()" placeholder="Select country" formControlName="countries" multiple>
              <div class="form-field-container">
                <mat-form-field class="gingr-input-wrapper w-full country-search" appearance="outline">
                  <input id="country-search-input" matInput placeholder="Search" type="text" [formControl]="countrySearchTextInput" />
                </mat-form-field>
              </div>
              @for (value of getCountriesAndRegions(); track value._id) {
                <div [ngClass]="{ hidden: !value.name.toLowerCase().includes(countrySearchTextInput.value?.toLowerCase() ?? '') }">
                  <mat-option [value]="value._id">{{ value.name }}</mat-option>
                </div>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</div>
